import {createContext, useEffect} from "react";
import useLocalStorage from 'use-local-storage';

interface ThemeContextType {
    theme: string, 
    toggleTheme: (theme: string)=> void,
}

const ThemeContext = createContext<ThemeContextType>({
    theme: 'light',
    toggleTheme: ()=>{}
});

const ThemeProvider = ({children}: any) => {
    const defaultLight = window.matchMedia('(prefers-color-scheme: light)').matches;
    const [theme, setTheme] = useLocalStorage('theme', defaultLight ? 'light' : 'dark');

    const toggleTheme = () => {
        const newTheme = theme === 'dark' ? 'light' : 'dark';
        setTheme(newTheme);
    }

    useEffect(() => {
        if (theme === 'light') {
            document.body.classList.remove('dark-theme');
            document.body.classList.add('light-theme');
        } else if (theme === 'dark') {
            document.body.classList.remove('light-theme');
            document.body.classList.add('dark-theme');
        }
    }, [theme]);

    return (
        <ThemeContext.Provider value={{theme, toggleTheme}}>
            {children}
        </ThemeContext.Provider>
    );
}

export {ThemeProvider, ThemeContext};